import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateFirestopItemAsDeleted = async (
  projectId,
  firestopItemId
) => {
  const apiPath = `firestop-documentation/project/${projectId}/firestop/${firestopItemId}/delete-firestop-item`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {},
  });
  const response = await axios(signedRequest);

  return response.data;
};
